<div class="d-flex justify-content-center align-items-center rounded" [ngClass]="{'small-icon-container' : height == 35}">
  <svg-icon [src]="'assets/icons/' + icon + '.svg'" [svgStyle]="{'height.px':height}" [title]="title" class="svg-secondary-text">
  </svg-icon>
  <span *ngIf="showBadge" class="badge bg-danger badge-dot badge-custom" [ngClass]="{'numbered': unReadMessages > 1}"><span *ngIf="unReadMessages > 1">{{ unReadMessages }}</span></span>
</div>
